<template>
  <div class="shadow-sm">
    <nav class="navbar navbar-expand-lg navbar-vertical p-0 sidebarNav" id="sidebarNav">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="collapse navbar-collapse align-content-stretch flex-wrap"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav flex-column w-100 pt-4 pl-1">
          <li class="nav-item" :class="{active : $route.name === 'applicationList'}">
              <a
                class="nav-link"
                href="javascript:void(0)"
                @click="goTo('/applicationList')"
              >
                <img src="../../assets/img/icons/application_setup_active.png" alt="" class="mr-2 sidebar_icon"> <span class="linkName">Applications List</span>
              </a>
          </li>
          <li class="nav-item" v-if="$route.name !== 'applicationList' && $route.name !== 'manageRequest' && $route.name !== 'profile' && $route.name !== 'changePassword'">
            <a
              class="nav-link"
              href="#"
              data-toggle="collapse"
              data-target="#applicationSetup"
              :aria-expanded="isAppAreaExpanded"
              aria-controls="navDashboard"
            >
              <img src="../../assets/img/icons/expression_builder_inactive.png" alt="" class="mr-2 sidebar_icon">
              <span class="linkName">Application</span>
              <span class="ml-auto mr-2">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
            </a>
            <div id="applicationSetup" class="collapse" :class="{show: isAppAreaExpanded}" data-parent="#sidebarNav">
              <ul class="nav flex-column subMenu" v-if="$route.name === 'createApplication'">
                <!-- <li class="nav-item"  :class="{active : $route.name === 'createApplication'}"> -->
                <li class="nav-item">
                  <a
                    class="nav-link"
                    href="#"
                    data-toggle="collapse"
                    data-target="#edit"
                    :aria-expanded="$route.name === 'createApplication'"
                  >
                  <img src="../../assets/img/icons/module_sele_inactive.png" alt="" class="mr-2 sidebar_icon">
                  <span class="linkName">Edit</span>
                  </a>
                </li>
                <div id="edit" class="collapse" :class="{show: $route.name === 'createApplication'}">
                  <ul class="nav flex-column subMenu nestedSubMenu">
                    <li class="nav-item"  :class="{active : $route.name === 'createApplication' && $route.params.id === 'setup'}">
                      <a class="nav-link" href="#/createApplication/setup">
                      <span class="linkName">Application Setup</span>
                      </a>
                    </li>
                    <li class="nav-item"  :class="{active : $route.name === 'createApplication' && $route.params.id === 'modules'}">
                      <a class="nav-link" href="#/createApplication/modules">
                      <span class="linkName">Module Selection</span>
                      </a>
                    </li>
                    <li class="nav-item"  :class="{active : $route.name === 'createApplication' && $route.params.id === 'dataUpload'}">
                      <a class="nav-link" href="#/createApplication/dataUpload">
                      <span class="linkName">Data Upload</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </ul>
              <ul class="nav flex-column subMenu" v-else-if="$route.name === 'training_wizard'">
                <li class="nav-item"  :class="{active : $route.name === 'training_wizard'}">
                  <a class="nav-link" href="#/training_wizard">
                  <img src="../../assets/img/icons/module_sele_inactive.png" alt="" class="mr-2 sidebar_icon">
                  <span class="linkName">Edit</span>
                  </a>
                </li>
              </ul>
              <ul class="nav flex-column subMenu" v-else>
                <!-- <li class="nav-item"  :class="{active : $route.name === 'wizard'}"> -->
                <li class="nav-item">
                  <a
                    class="nav-link"
                    href="#"
                    data-toggle="collapse"
                    data-target="#edit"
                    :aria-expanded="$route.name === 'wizard'"
                  >
                  <img src="../../assets/img/icons/module_sele_inactive.png" alt="" class="mr-2 sidebar_icon">
                  <span class="linkName">Edit</span>
                  <span class="ml-auto mr-2">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                  </span>
                  </a>
                </li>
                <div id="edit" class="collapse" :class="{show: $route.name === 'wizard'}">
                  <ul class="nav flex-column subMenu nestedSubMenu">
                    <li class="nav-item"  :class="{active : $route.name === 'wizard' && $route.params.id === 'setup'}">
                      <a class="nav-link" href="#/wizard/setup">
                      <span class="linkName">Application Setup</span>
                      </a>
                    </li>
                    <li class="nav-item"  :class="{active : $route.name === 'wizard' && $route.params.id === 'modules'}">
                      <a class="nav-link" href="#/wizard/modules">
                      <span class="linkName">Module Selection</span>
                      </a>
                    </li>
                    <li class="nav-item"  :class="{active : $route.name === 'wizard' && $route.params.id === 'dataUpload'}">
                      <a class="nav-link" href="#/wizard/dataUpload">
                      <span class="linkName">Data Upload</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <!-- <li class="nav-item"  :class="{active : $route.name === 'indicatorAdd'}"> -->
                <li class="nav-item">
                  <a
                    class="nav-link"
                    href="#"
                    data-toggle="collapse"
                    data-target="#derivedIndicators"
                    :aria-expanded="isIndAreaExpanded"
                  >
                    <img src="../../assets/img/icons/indicator.png" alt="" class="mr-2 sidebar_icon">
                    <span class="linkName">Derived Indicators</span>
                    <span class="ml-auto mr-2">
                      <i class="fa fa-chevron-down" aria-hidden="true"></i>
                    </span>
                  </a>
                </li>
                <div id="derivedIndicators" class="collapse" :class="{show: isIndAreaExpanded}">
                  <ul class="nav flex-column subMenu nestedSubMenu">
                    <li class="nav-item"  :class="{active : $route.name === 'indicatorType'}">
                      <a class="nav-link" href="#/indicatorType">
                      <span class="linkName">Indicator Type</span>
                      </a>
                    </li>
                    <li class="nav-item"  :class="{active : $route.name === 'indicatorAdd'}">
                      <a class="nav-link" href="#/indicatorAdd">
                      <span class="linkName">Indicator</span>
                      </a>
                    </li>
                    <li class="nav-item"  :class="{active : $route.name === 'indicatorGroup'}">
                      <a class="nav-link" href="#/indicatorGroup">
                      <span class="linkName">Indicator Group</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <li class="nav-item"  :class="{active : $route.name === 'outlierAdd'}">
                  <a class="nav-link" href="#/outlierAdd">
                  <img src="../../assets/img/icons/alert.png" alt="" class="mr-2 sidebar_icon">
                  <span class="linkName">Alert</span>
                  </a>
                </li>
                <li class="nav-item"  :class="{active : $route.name === 'organisationGroup'}">
                  <a class="nav-link" href="#/organisationGroup">
                  <img src="../../assets/img/icons/access.png" alt="" class="mr-2 sidebar_icon">
                  <span class="linkName">Location Group</span>
                  </a>
                </li>
                <li class="nav-item"  :class="{active : $route.name === 'organisationUnit'}">
                  <a class="nav-link" href="#/organisationUnit">
                  <img src="../../assets/img/icons/gml_update_g.png" alt="" class="mr-2 sidebar_icon">
                  <span class="linkName">GML Update</span>
                  </a>
                </li>
                <li class="nav-item"  :class="{active : $route.name === 'deleteMetaData'}">
                  <a class="nav-link" href="#/deleteMetaData">
                  <img src="../../assets/img/icons/delete.png" alt="" class="mr-2 sidebar_icon">
                  <span class="linkName">Delete Metadata</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-item" :class="{active : $route.name === 'manageRequest'}" v-if="isAdmin">
              <a
                class="nav-link"
                href="javascript:void(0)"
                @click="goTo('/manageRequest')"
              >
                <img src="../../assets/img/icons/request_dashboard.png" alt="" class="mr-2 sidebar_icon"> <span class="linkName">Manage Requests</span>
              </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
import ApiServices from "../../service/ApiServices";
export default {
  props: ['isSidebarToggle'],
  data() {
    return {
      baseUrl: "http://localhost:8080/dhis/",
      dashboardUrl: "api/apps/Avenir-Generic/index.html#/",
      settings: settings,
      isAdmin: false
    };
  },
  computed: {
    isAppEdit: function () {
      return sessionStorage.getItem('appId') && sessionStorage.getItem('appUserId')
    },
    isAppAreaExpanded: function() {
      return this.$route.name === 'training_wizard' || this.$route.name === 'createApplication' || this.$route.name === 'wizard' || this.$route.name === 'indicatorAdd' || this.$route.name === 'indicatorType' || this.$route.name === 'indicatorGroup' || this.$route.name === 'outlierAdd' || this.$route.name === 'organisationGroup' || this.$route.name === 'organisationUnit' || this.$route.name === 'deleteMetaData'

    },
    isIndAreaExpanded: function() {
      return this.$route.name === 'indicatorType' || this.$route.name === 'indicatorAdd' || this.$route.name === 'indicatorGroup'
    }
  },
  methods: {
    copyToClipboard(e) {
      //console.log(e.target.getAttribute('data-link'));
      var dummy = document.createElement("input"),
        text = e.target.getAttribute("data-link");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    },
    logout() {
      //dhis-web-commons-security/logout.action
      localStorage.removeItem("userProfile");
      localStorage.removeItem("loggedInUserId");
      ApiServices.RestGetCall(
        "dhis-web-commons-security/logout.action",
        {}
      ).then(res => {
        console.log(res);
      });
      //window.open('http://intraavenir.duredemos.com/service/dhis-web-commons-security/logout.action', '_blank');
      this.$router.push("/");
    },
    goTo(path) {
      sessionStorage.removeItem('appId')
      sessionStorage.removeItem('appUserId')
      this.$router.push(path)
    }
  },
  mounted() {
    this.baseUrl = ApiServices.getBaseUrl();
    this.dashboardUrl = this.baseUrl + this.dashboardUrl;
    let userProfile = JSON.parse(localStorage.getItem("userProfile"));
    if(userProfile && settings.userRole.includes(userProfile.userrole)){
        this.isAdmin = true
    }
    // console.log(this.dashboardUrl)
  }
};
</script>
<style lang="scss" scoped>
.corner_icon img {
  width: 68%;
  display: block;
  margin-top: 10px;
  margin: 0px auto;
}
.navIconUser {
  font-size: 18px;
}
.navbar-vertical.navbar-expand-lg .navbar-nav .nav-link {
}

/** sidebar width*/
.navbar-vertical.navbar-expand-lg {
  display: block;
    position: fixed;
    top: 85px;
    bottom: 0;
    overflow-y: auto;
    width: 65px;
    z-index: 9;
    -webkit-transition: .5s;
    transition: .5s;
}

.navbar-vertical .navbar-nav .nav-link {
  display: flex;
  align-items: center;
}

.navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav-link {
  //padding-left: 2.25rem;
}

.navHeading {
  padding-left: 0.35rem;
}
.navPagesSub .nav-item .nav-link {
  padding-left: 3.25rem !important;
}
.sidebarNav {
  background: #273649 !important;
  .navbar-brand {
    background: #14191f !important;
    width: 100%;
    // padding: 12px;
    padding: 12px 12px 4px;
    height:71px;

  }
  .navbar-nav{
    li{
      .nav-link{
        color: #b9c8db !important;
        font-size: 16px;
        padding-left: 16px;
        height: 60px;
        .fa{
          color: #b9c8db !important;

        }
        i.fa.fa-chevron-down {
          font-size: 0.75rem;
        }
        span{
          color: #b9c8db !important;
          display: none;
          position: relative;
          animation: mymove 1s;
          font-family: 'Montserrat-Regular';

        }
        .linkName{
          margin-left : 6%;
          font-size: 14px;
        }
      }
    }
    .nav-item:hover{
      background: #2e3f53 !important;
      text-decoration: none;
    }
    .nav-item.active{
      background: #f4f4f4 !important;
      border-left: 6px solid #fe5768;
    }
    .nav-item.active .nav-link span, .nav-item.active .fa{
      color: #273649!important;
    }

    .nav-item a:hover{
      text-decoration: none !important;
    }
  }

  .subMenu{
      background: #39495c;
    .nav-link{
      font-size: 0.8125rem;
    }
    .nav-item.active{
      background: #f4f4f4 !important;
      border-left: 6px solid #fe5768;
    }
    .nav-item.active .nav-link span{
      color: #273649!important;
    }
  }

}
// .sidebar_icon {
//     width: 8%;
// }


.navbar-vertical.navbar-expand-lg:hover{
  width:250px;
  box-shadow: 3px 0px 4px rgba(39, 54, 73, .20);
}
.navbar-vertical.navbar-expand-lg:hover .nav-link span{
  display: block;

}
@keyframes mymove {
  from {left: 100px;}
  to {left: 0px;}
}
.toggalclass .sidebarNav .navbar-nav li .nav-link span{
  display: block;
}
.toggalclass .navbar-vertical.navbar-expand-lg:hover{
  box-shadow: none;
}
.nestedSubMenu .nav-item .nav-link{
  padding-left: 45px !important;
}
.subMenu .nav-item .active{
  background: #2e3f53 !important;
  text-decoration: none;
}
.sidebarNav .nestedSubMenu{
  background: #273649;
}
</style>
